"use client";

import { Content } from "@/services/content/types";
import { createContext, PropsWithChildren, useContext, useState } from "react";

type PlayerContextType = {
  podcast: Content.PodcastEpisode | null;
  isCollapsed: boolean;
  openPodcast: (podcast: Content.PodcastEpisode) => void;
  closePodcast: () => void;
  toggleCollapsed: () => void;
};

export const PlayerContext = createContext<PlayerContextType>({
  podcast: null,
  isCollapsed: false,
  openPodcast: () => null,
  closePodcast: () => null,
  toggleCollapsed: () => null,
});

export const PlayerContextProvider = ({ children }: PropsWithChildren) => {
  const [podcast, setPodcast] = useState<Content.PodcastEpisode | null>(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <PlayerContext.Provider
      value={{
        podcast,
        isCollapsed,
        openPodcast: (podcast) => {
          setIsCollapsed(false);
          setPodcast(podcast);
        },
        closePodcast: () => setPodcast(null),
        toggleCollapsed: () => setIsCollapsed((collapsed) => !collapsed),
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => {
  const { podcast, isCollapsed, openPodcast, closePodcast, toggleCollapsed } =
    useContext(PlayerContext);

  return { podcast, isCollapsed, openPodcast, closePodcast, toggleCollapsed };
};
